import type { Message, SavedChat, UnavailableArtifact } from "~/helpers/aiChat/chatStorage";
import type { ArtifactResult } from "~/services/aiOrchestrator";

export const MAX_PERSISTED_ARTIFACT_CHARS = 1_000_000;

const messageArtifactChars = (artifacts: ArtifactResult[]): number =>
	artifacts.reduce((total, artifact) => total + artifact.contentBase64.length, 0);

const toUnavailableArtifact = (artifact: ArtifactResult): UnavailableArtifact => ({
	filename: artifact.filename,
	mimeType: artifact.mimeType
});

const downgradeMessage = (message: Message): Message => {
	const { reportArtifacts, ...rest } = message;
	return { ...rest, unavailableReportArtifacts: (reportArtifacts ?? []).map(toUnavailableArtifact) };
};

const applyArtifactBudget = (chats: SavedChat[], maxChars: number = MAX_PERSISTED_ARTIFACT_CHARS): SavedChat[] => {
	let remainingChars = maxChars;
	const budgetReportArtifacts = (message: Message): Message => {
		if (!message.reportArtifacts || message.reportArtifacts.length === 0) return message;
		const chars = messageArtifactChars(message.reportArtifacts);
		if (chars <= remainingChars) {
			remainingChars -= chars;
			return message;
		}
		return downgradeMessage(message);
	};
	const budgetLayouts = (message: Message): Message => {
		if (!message.layouts) return message;
		const chars = JSON.stringify(message.layouts).length;
		if (chars <= remainingChars) {
			remainingChars -= chars;
			return message;
		}
		const { layouts, ...rest } = message;
		return rest;
	};
	return chats.map((chat) => ({
		...chat,
		messages: chat.messages.map((message) => budgetReportArtifacts(budgetLayouts(message)))
	}));
};

export default applyArtifactBudget;
